import { ChangeEvent, KeyboardEvent, useEffect, useRef, useState } from 'react'
import { ENTER_KEY } from 'constants/key-codes'

export const DEFAULT_HEIGHT = 52
export const MAX_CHARS = 200
export const CHAR_LIMIT_WARNING = 10

const adjustTextareaHeight = (textarea: HTMLTextAreaElement) => {
  textarea.style.height = `${DEFAULT_HEIGHT}px`
  textarea.style.height = `${Math.max(textarea.scrollHeight, DEFAULT_HEIGHT)}px`
}

const useResizableNote = (note: string) => {
  const [charCount, setCharCount] = useState(note?.length || 0)

  const inputRef = useRef<HTMLInputElement>(null)
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (textareaRef.current && note) {
      adjustTextareaHeight(textareaRef.current)
    }
  }, [])

  const handleTextareaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const textarea = e.target
    const currentLength = textarea.value.length
    setCharCount(currentLength)

    setTimeout(() => {
      adjustTextareaHeight(textarea)
    }, 0)
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLFormElement>) => {
    if (e.key === ENTER_KEY) {
      e.preventDefault()
      inputRef.current?.blur()
      textareaRef.current?.blur()
    }
  }

  return {
    inputRef,
    textareaRef,
    charCount,
    setCharCount,
    handleKeyDown,
    handleTextareaChange,
  }
}

export default useResizableNote
